<template>
  <div class="index">
    <Modal
      v-model="show"
      title="操作记录"
      width="60"
      :footer-hide="true"
    >
      <div class="modal-main">
        <div class="search" style="margin-bottom: 12px">
          <Input
            v-model="srtKey"
            placeholder="请输入操作说明关键字检索"
            style="width: 260px"
            clearable
          ></Input>
          <Button
            type="primary"
            style="margin-left: 12px"
            @click="handleSearch"
          >查询</Button>
        </div>
        <div class="table-main">
          <Table
            :columns="columns"
            :data="tableData"
            :loading="loading"
            border
            max-height="500"
          >
            <template slot="codeType" slot-scope="{ row }">
              {{ codeTypeMap[row.codeType] }}
            </template>
            <template slot="opDesc" slot-scope="{ row }">
              <p v-if="hasDownload">
                {{ getOpDesc(row.opDesc).creator?`${getOpDesc(row.opDesc).creator} ${getOpDesc(row.opDesc).fileName}`: getOpDesc(row.opDesc).content }}
                <span v-if="isFileName">{{ getOpDesc(row.opDesc).fileName }}</span>
                <span
                  v-if="getOpDesc(row.opDesc).fileId"
                  class="color-blue cursor-pointer"
                  @click="handleDownload(getOpDesc(row.opDesc))"
                >
                  >>立即下载</span>
              </p>
              <p v-else>{{ row.opDesc }}</p>
            </template>
          </Table>
        </div>
        <div class="paging">
          <Page
            :current="pageInfo.pageNum"
            :total="pageInfo.total"
            show-total
            show-elevator
            @on-change="handlePageInfoChange"
          ></Page>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import orderCenterApi from '@/request/orderCenter/index.js';
import cateringAdmin from '@/request/cateringAdmin/index.js';
export default {
  props: {
    codeTypeMap: {
      type: Object,
      default: () => { }
    },
    hasDownload: {
      type: Boolean,
      default: false
    },
    isFileName: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      columns: [{
        title: '操作类型',
        slot: 'codeType',
        width: 230
      }, {
        title: '操作人',
        key: 'creatorName',
        width: 130
      }, {
        title: '操作时间',
        key: 'createTime',
        width: 180
      }, {
        title: '说明',
        slot: 'opDesc'
      }],
      tableData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      srtKey: '',
      loading: false,
      recParams: {}// 操作记录需要的独特入参，例如objectId、recType等
    };
  },
  methods: {
    async getOperateRecPage() {
      this.loading = true;
      const res = await orderCenterApi.getOperateRecPage({
        strKey: this.srtKey,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        ...this.recParams
      });
      this.loading = false;
      if (res.status == 200) {
        this.tableData = res.message.list.map(item => {
          let str = item.opDesc;
          if (item.codeType === 'SET_CONFIG_OF_REFUND_APPROVE_SCH_PERMISSION') {
            const reg = /^(操作了)(\D+)/;
            str = item.opDesc.replace(reg, `$1【${item.objectName}】$2`);
          }
          return {
            ...item,
            opDesc: str
          };
        });
        this.pageInfo.total = Number(res.message.total);
      }
    },
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getOperateRecPage();
    },
    // 分页
    handlePageInfoChange(current) {
      this.pageInfo.pageNum = current;
      this.getOperateRecPage();
    },
    handleShow(recParams = {}) {
      this.recParams = recParams;
      this.show = true;
      this.srtKey = '';
      this.pageInfo.pageNum = 1;
      this.getOperateRecPage();
    },
    getOpDesc(desc) {
      try {
        const obj = JSON.parse(desc);
        return obj;
      } catch (err) {
        return {
          content: desc,
          fileName: '',
          fileId: ''
        };
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          fileId: [fileId],
          type: 2
        };
        const res = await cateringAdmin.getDownloadtoken(params);
        if (res.status === 200) {
          this.downloadUrl = res.message.downUrl;
          this.downloadToken = res.message.token;
        }
        resolve();
      });
    },
    async handleDownload({ fileId, fileName }) {
      await this.getDownloadtoken(fileId);

      const href = `${this.downloadUrl}?fileId=${fileId}`;
      const downloadElement = document.createElement('a');
      downloadElement.style.display = 'none';
      downloadElement.href = href;

      downloadElement.download = fileName; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    }
  }
};
</script>
